import Vue from 'vue'
import {mapGetters} from 'vuex'
import genericSvgIcon from 'js/components/_moverick/generic-svg-icon'

import template from './index.pug'

export default Vue.extend({
  name: 'card-journey',
  template: template(),

  components: {
    genericSvgIcon
  },

  props: {
    datos: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      transferProperty: 'is_transfer',
      cappingProperty: 'hop_type',
      operatorNameValue: '',
      cappingModalVisible: false
    }
  },

  computed: {
    ...mapGetters('user', [
      'modalCapping',
      'journeysByYearMonth',
      'products'
    ]),

    ...mapGetters([
      'operators'
    ]),

    productIds() {
      return this.products.map(i => i.id)
    },

    originStop() {
      return this.transaction?.stop_from?.name || this.datos?.origin_stop_name || ''
    },

    destinationStop() {
      return this.transaction?.stop_to?.name || this.datos?.stop_to?.name || ''
    },

    hasDestinationStop() {
      return !_.isEmpty(this.destinationStop)
    },

    profileName() {
      const profileCode = this.transaction?.profile_code || this.datos?.profile_code
      const profile = this.$administrativeArea?.media_profiles?.find(
        mediaProfile => mediaProfile.code === profileCode
      )
      const profileName = profile?.name || ''

      if (profileName === 'Public General') {
        return this.$t('travels.publicGeneral')
      }

      return profileName
    },

    routeShortName() {
      return this.transaction?.linea_actual ||
        this.datos?.route?.short_name ||
        this.transaction?.line_code ||
        ''
    },

    transaction() {
      const journeyId = _.get(this.datos, '_id') || this.datos?.id

      return this.getTransactionById(journeyId)
    },

    journeyStages() {
      return this.datos?.transfer_stages || [this.datos]
    },

    getTscDate() {
      if (!_.has(this.datos, 'operation_date')) return ''

      const TSCdate = moment(this.datos.operation_date)

      return TSCdate.format('DD/MM/YY H:mm')
    },

    paymentTypeText() {
      if(this.datos.payment_media_type) {
        return this.datos.payment_media_type.split('::')[1].toLowerCase()
      }

      return this.$store.getters['user/getPaymentTypeText'](this.datos.media_type)
    },

    paymentTypeIcon() {
      const paymentMediaType = this.datos.payment_media_type || this.transaction?.payment_media_type || ''

      if (paymentMediaType.includes('Passenger::Tsc')) return 'tne'
      if (paymentMediaType.includes('Passenger::Qr')) return 'qr-mini'

      return this.$store.getters['user/paymentTypeIcon'](this.datos.media_type)
    },

    getOperator() {
      return this.$store.getters.operatorById(this.transaction?.operator_id)
    },

    operatorName(){
      return this.getOperator?.name || ''
    },

    external_code() {
      if (!_.has(this.datos, 'media_code')) return ''

      return this.datos.media_code
    },

    transferText() {
      return this.isTransfer ? ` - ${this.$t('travels.transfer')}` : ''
    },

    isTransfer() {
      return this.isTransferValue(this.transaction?.[this.transferProperty]) ||
        this.isTransferValue(this.datos?.[this.transferProperty])
    },

    isCapping() {
      return this.journeyStages.some(stage => {
        const transaction = this.stageTransaction(stage)

        return this.hasCappingApplied(transaction) || this.hasCappingApplied(stage)
      })
    },

    cappingStage() {
      return this.journeyStages.find(stage => {
        const transaction = this.stageTransaction(stage)

        return this.hasCappingApplied(transaction) || this.hasCappingApplied(stage)
      }) || this.datos
    },

    cappingZone() {
      const transaction = this.stageTransaction(this.cappingStage)

      return transaction?.crossed_areas ||
        this.cappingStage?.crossed_areas ||
        this.datos?.crossed_areas ||
        '-'
    },

    cappingMessage() {
      return this.$t('travels.capping.message', {zone: this.cappingZone})
    },

    spansYears() {
      return Object.keys(this.journeysByYearMonth).length > 1
    }
  },

  methods: {
    ...mapGetters('user', [
      // 'operatorById',
      // 'getPaymentTypeText'
    ]),
    getTransactionById(id) {
      return this.$store.getters['user/transactionById'](id)
    },

    isTransferValue(value) {
      return value === true || value === 1 || value === '1'
    },
    hasCappingApplied(transaction) {
      return transaction?.capping_applied === true ||
        (!_.isNil(transaction?.capping_limit) && !_.isNil(transaction?.capping_sum))
    },
    stageTransaction(stage) {
      const journeyId = _.get(stage, '_id') || stage?.id

      return this.getTransactionById(journeyId) || stage
    },
    stageOriginStop(stage) {
      const transaction = this.stageTransaction(stage)

      return transaction?.stop_from?.name || stage?.origin_stop_name || stage?.stop?.name || ''
    },
    stageRouteShortName(stage) {
      const transaction = this.stageTransaction(stage)

      return transaction?.linea_actual ||
        stage?.route?.short_name ||
        transaction?.line_code ||
        ''
    },
    stageOperatorName(stage) {
      const transaction = this.stageTransaction(stage)
      const operator = this.$store.getters.operatorById(transaction?.operator_id)

      return operator?.name || this.operatorName
    },
    stageDate(stage) {
      if (!_.has(stage, 'operation_date')) return ''

      return moment(stage.operation_date).format('DD/MM/YY H:mm')
    },
    stageTransferText(stage) {
      const transaction = this.stageTransaction(stage)
      const isTransfer = this.isTransferValue(transaction?.[this.transferProperty]) ||
        this.isTransferValue(stage?.[this.transferProperty])

      return isTransfer ? ` - ${this.$t('travels.transfer')}` : ''
    },
    cappingInfo() {
      this.cappingModalVisible = true
    },
    closeCappingInfo() {
      this.cappingModalVisible = false
    }
  }
})
